import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';

import {defaultRows} from '../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../util/Rest';
import {useDispatch} from 'react-redux';
import {fetchFilterGroup} from '../../../redux/reducers/EnableFramework/FilterGroup';
import GuiTable from '../../../components/FormComponents/GuiTable';
// redux/reducers/EnableFramework/FilterGroup
export default function FilterGroupSearchTable({
  submit,
  setSubmit,
  setSelectedFilterGroupCode,
  searchData,
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setRecordFormatFilterGroupId,
  setFilterGroupCode,
}) {
  const columns = [
    {
      title: 'Filter Group Code',
      field: 'filterGroupCode',
    },
    {
      title: 'Filter Group Name',
      field: 'filterGroupName',
    },
    {
      title: 'Filter Group Description',
      field: 'filterGroupDescription',
    },
  ];

  const tableRef = createRef();
  // const [rows, setRows] = useState(defaultRows);
  const rows = defaultRows;
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/filtergroup`;
                const bodyObj = {
                  filterGroupDescription: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  filterGroupCode: searchData?.code ? searchData.code : '',
                  filterGroupName: searchData?.displayName ? searchData.displayName : '',
                  page:
                    submit ?
                      1 :
                      arrayLast && query.page >= 1 ?
                        query.page :
                        arrayLast ?
                          (query.page <= 1 && query.page + 1) || query.page - 1 :
                          query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbar: false,
              search: false,
              // selection: true,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onRowClick={(event, rowData) => {
              if (handleClose && setRecordFormatFilterGroupCode) {
                setRecordFormatFilterGroupCode(rowData.filterGroupCode);
                setRecordFormatFilterGroupId(rowData?.filterGroupId);
                handleClose();
              } else if (handleClose) {
                setSelectedFilterGroupCode(rowData.filterGroupCode);
                setRecordFormatFilterGroupId(rowData?.filterGroupId);
                dispatch(fetchFilterGroup(rowData.filterGroupId));
                handleClose();
              } else {
                setTabValue(1);
                setFilterGroupCode(rowData?.filterGroupCode);
                setRecordFormatFilterGroupId(rowData?.filterGroupId);
                dispatch(fetchFilterGroup(rowData.filterGroupId));
              }
            }}
          />
        </div>
      </Grid>
    </>
  );
}
